import { render, staticRenderFns } from "./IslamicFinanceFormModal.vue?vue&type=template&id=0df4035a"
import script from "./IslamicFinanceFormModal.vue?vue&type=script&lang=js"
export * from "./IslamicFinanceFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df4035a')) {
      api.createRecord('0df4035a', component.options)
    } else {
      api.reload('0df4035a', component.options)
    }
    module.hot.accept("./IslamicFinanceFormModal.vue?vue&type=template&id=0df4035a", function () {
      api.rerender('0df4035a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/islamicFinanceModal/IslamicFinanceFormModal.vue"
export default component.exports